<script setup lang="ts">
import packageInfo from "~/package.json";
import { Ibar, Footer, SnackbarManager } from "@frontiers-vue3/public-pages";
import { addPackageToWindowFrontiers } from "~/helpers";
import { useJournalPagesService } from "~/composables/useJournalPagesService";

addPackageToWindowFrontiers(packageInfo);
const terminology = useTerminologyStore();
const main = useMain();

const jsonLdSchema = useSchemaService().getResearchTopicSchema(
  main.currentResearchTopic
);

useHead({
  title: `${useSanitizeHtml(main.currentResearchTopic.title, {
    ALLOWED_TAGS: ["sub", "sup"]
  })} | ${terminology.getTerm("tenantName")} ${terminology.getTerm(
    "researchTopic"
  )} Magazine`,
  script: [
    {
      type: "application/ld+json",
      innerHTML: JSON.stringify(jsonLdSchema)
    }
  ]
});

onBeforeMount(() => {
  main.fetchTotals();
});

const { data } = useAsyncData("ibar-footer", async () => {
  if (import.meta.client) {
    return useNuxtApp().payload.data["ibar-footer"] ?? null;
  }

  try {
    const { getIbarComponent, getFooterComponent } = useJournalPagesService();
    const ibar = await getIbarComponent(main.getPrimaryJournalId);
    const footer = await getFooterComponent();
    return { ibar, footer };
  } catch {
    // Don't surface journal-pages / auth failures as a Nuxt error page on magazine.
    return null;
  }
});
</script>
<template>
  <button class="BypassBlock__firstEl"></button>
  <a
    href="#main-content"
    class="BypassBlock__wrapper">
    <span class="BypassBlock__button">Skip to main content</span>
  </a>
  <div :theme="main.colorPalette">
    <Ibar
      v-if="data"
      v-bind="data.ibar"
      about-journal-text="About journal" />
    <div class="MagazineLayout">
      <NuxtPage />
    </div>
    <Footer
      v-if="data"
      v-bind="data.footer" />
    <SnackbarManager />
  </div>
</template>
<style lang="scss">
.MagazineLayout {
  margin: calc(var(--ibar-height) + var(--ibar-mix-height)) auto 0 auto;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;

  @media #{$break-md} {
    margin: var(--ibar-height) auto;
  }
}
.SnackbarManager {
  @media #{$break-md} {
    bottom: 32px;
  }

  @media #{$break-xs} {
    bottom: 16px;
  }
}
</style>
